import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Affiliates',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              target: 'ent:!org:!affiliate',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      boardSize: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'boardSize',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      newDonors: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'newDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      majorGifts: {
                        '{}': {
                          value: {
                            '@': 'revenueMajorGifts',
                          },
                        },
                      },
                      staffCount: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'staffCount',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      girlsServed: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'girlsServed',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      onlineSplit: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'onlineSplit',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      grantWriting: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'grantWriting',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      lapsedDonors: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'lapsedDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      otherRevenue: {
                        '{}': {
                          value: {
                            '@': 'revenueOtherRevenue',
                          },
                        },
                      },
                      serviceRegion: {
                        '{}': {
                          value: {
                            '@.': '!service_region',
                          },
                        },
                      },
                      specialEvents: {
                        '{}': {
                          value: {
                            '@': 'revenueIndividualGiving',
                          },
                        },
                      },
                      caseForSupport: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'caseForSupport',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      currentRevenue: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'currentRevenue',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      retainedDonors: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'retainedDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      boardEngagement: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'boardEngagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      digitalPresence: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'digitalPresence',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      eventManagement: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'eventManagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      givingFrequency: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'givingFrequency',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      foundationGrants: {
                        '{}': {
                          value: {
                            '@': 'revenueFoundationGrants',
                          },
                        },
                      },
                      individualGiving: {
                        '{}': {
                          value: {
                            '@': 'revenueIndividualGiving',
                          },
                        },
                      },
                      yearsInOperation: {
                        '{}': {
                          value: {
                            '@.': '!years_in_operation',
                          },
                        },
                      },
                      governmentFunding: {
                        '{}': {
                          value: {
                            '@': 'revenueGovernmentFunding',
                          },
                        },
                      },
                      totalActiveDonors: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'totalActiveDonors',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      dataAnalyticsUsage: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'dataAnalyticsUsage',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      donorLifetimeValue: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'donorLifetimeValue',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      marketingMaterials: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'marketingMaterials',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      majorGiftExperience: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'majorGiftExperience',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      stewardshipPrograms: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'stewardshipPrograms',
                                ],
                              },
                            ],
                          },
                        },
                      },
                      corporateSponsorships: {
                        '{}': {
                          value: {
                            '@': 'revenueCorporateSponsorships',
                          },
                        },
                      },
                      donorDatabaseManagement: {
                        '{}': {
                          value: {
                            '->': [
                              {
                                '@': 'assessments',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'donorDatabaseManagement',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'details',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                assessments: {
                  ref: {
                    attr: 'attr:ent#!assessments#!asssessment:!affiliate',
                  },
                  target: 'ent:!assessments:!assessment',
                  selection: {
                    '{}': {
                      boardSize: {
                        '@.': '!board_size',
                      },
                      newDonors: {
                        '@.': '!new_donors',
                      },
                      staffCount: {
                        '@.': '!staff_count',
                      },
                      girlsServed: {
                        '@.': '!girls_served',
                      },
                      onlineSplit: {
                        '@.': '!online_split',
                      },
                      grantWriting: {
                        '@.': '!grant_writing',
                      },
                      lapsedDonors: {
                        '@.': '!lapsed_donors',
                      },
                      caseForSupport: {
                        '@.': '!case_for_support',
                      },
                      currentRevenue: {
                        '@.': '!current_revenue',
                      },
                      retainedDonors: {
                        '@.': '!retained_donors',
                      },
                      boardEngagement: {
                        '@.': '!board_engagement',
                      },
                      digitalPresence: {
                        '@.': '!digital_presence',
                      },
                      eventManagement: {
                        '@.': '!event_management',
                      },
                      givingFrequency: {
                        '@.': '!giving_frequency',
                      },
                      totalActiveDonors: {
                        '@.': '!total_active_donors',
                      },
                      dataAnalyticsUsage: {
                        '@.': '!data_analytics_usage',
                      },
                      donorLifetimeValue: {
                        '@.': '!donor_lifetime_value',
                      },
                      marketingMaterials: {
                        '@.': '!marketing_materials',
                      },
                      majorGiftExperience: {
                        '@.': '!major_gift_experience',
                      },
                      stewardshipPrograms: {
                        '@.': '!stewardship_programs',
                      },
                      donorDatabaseManagement: {
                        '@.': '!donor_database_management',
                      },
                    },
                  },
                },
                revenueMajorGifts: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?2',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenuSpecialEvents: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?7',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenueOtherRevenue: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?1',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenueFoundationGrants: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?5',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenueIndividualGiving: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?3',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenueGovernmentFunding: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?4',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                revenueCorporateSponsorships: {
                  ref: {
                    attr: 'attr:ent#!fs_entries#!fs_entry:!affiliate',
                  },
                  filter: {
                    '=': [
                      {
                        '@.': [
                          '!func_fs',
                          {
                            ref: {
                              entity: '!func',
                            },
                          },
                        ],
                      },
                      '?6',
                    ],
                  },
                  target: 'ent:!fs_entries:!fs_entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'girlsServed',
                  direct: {
                    '{}': {
                      name: 'Girls Served',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'currentRevenue',
                  direct: {
                    '{}': {
                      name: 'Current Revenue',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'staffCount',
                  direct: {
                    '{}': {
                      name: 'Staff Count',
                      type: 'DECIMAL',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'boardSize',
                  direct: {
                    '{}': {
                      name: 'Board Size',
                      type: 'DECIMAL',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'serviceRegion',
                  direct: {
                    '{}': {
                      name: 'Service Region',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'yearsInOperation',
                  direct: {
                    '{}': {
                      name: 'Years in Operation',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'individualGiving',
                  direct: {
                    '{}': {
                      name: 'Individual Giving',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'majorGifts',
                  direct: {
                    '{}': {
                      name: 'Major Gifts',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'foundationGrants',
                  direct: {
                    '{}': {
                      name: 'Foundation Grants',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'corporateSponsorships',
                  direct: {
                    '{}': {
                      name: 'Corporate Sponsorships',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'specialEvents',
                  direct: {
                    '{}': {
                      name: 'Special Events',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'governmentFunding',
                  direct: {
                    '{}': {
                      name: 'Government Funding',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'otherRevenue',
                  direct: {
                    '{}': {
                      name: 'Other Revenue',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'totalActiveDonors',
                  direct: {
                    '{}': {
                      name: 'Total Active Donors',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'newDonors',
                  direct: {
                    '{}': {
                      name: 'New Donors',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'retainedDonors',
                  direct: {
                    '{}': {
                      name: 'Retained Donors',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'lapsedDonors',
                  direct: {
                    '{}': {
                      name: 'Lapsed Donors',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'donorLifetimeValue',
                  direct: {
                    '{}': {
                      name: 'Donor Lifetime Value',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'givingFrequency',
                  direct: {
                    '{}': {
                      name: 'Giving Frequency',
                      type: 'DECIMAL',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'onlineSplit',
                  direct: {
                    '{}': {
                      name: 'Online Split',
                      type: 'PERCENT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'majorGiftExperience',
                  direct: {
                    '{}': {
                      name: 'Major Gift Experience',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'donorDatabaseManagement',
                  direct: {
                    '{}': {
                      name: 'Donor Database Management',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'boardEngagement',
                  direct: {
                    '{}': {
                      name: 'Board Engagement',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'grantWriting',
                  direct: {
                    '{}': {
                      name: 'Grant Writing',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'eventManagement',
                  direct: {
                    '{}': {
                      name: 'Event Management',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'stewardshipPrograms',
                  direct: {
                    '{}': {
                      name: 'Stewardship Programs',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'caseForSupport',
                  direct: {
                    '{}': {
                      name: 'Case For Support',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'marketingMaterials',
                  direct: {
                    '{}': {
                      name: 'Marketing Materials',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'digitalPresence',
                  direct: {
                    '{}': {
                      name: 'Digital Presence',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'dataAnalyticsUsage',
                  direct: {
                    '{}': {
                      name: 'Data Analytics Usage',
                      type: 'INT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'test.create.assessment.modal',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
